import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=3f70fcfb&scoped=true&"
import script from "./StudentList.vue?vue&type=script&lang=ts&"
export * from "./StudentList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=3f70fcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70fcfb",
  null
  
)

export default component.exports